import { useEffect, useMemo, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

const dayKey = (iso) => new Date(iso).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
const timeOf = (iso) => new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });

export const SlotPicker = ({ value, onPick, reloadKey, url = "/api/booking/slots", emptyText = "No open times right now — reply to your welcome email and we'll find a time." }) => {
  const [d, setD] = useState(null);
  const [day, setDay] = useState("");
  useEffect(() => { api.get(url).then(r => setD(r.data)).catch(() => setD({ slots: [] })); }, [reloadKey, url]);
  const days = useMemo(() => (d?.slots || []).reduce((m, s) => { (m[dayKey(s)] = m[dayKey(s)] || []).push(s); return m; }, {}), [d]);
  const keys = Object.keys(days);
  useEffect(() => { if (keys.length && !days[day]) setDay(keys[0]); }, [keys.join("|")]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return <Loader2 className="w-6 h-6 animate-spin text-blue-600" />;
  if (!keys.length) return <p className="text-sm text-slate-500" data-testid="slots-empty">{emptyText}</p>;
  return (
    <div data-testid="slot-picker">
      <p className="text-xs text-slate-400 mb-2">Times shown in your time zone ({Intl.DateTimeFormat().resolvedOptions().timeZone}) · {d.slot_minutes} min</p>
      <div className="flex gap-2 overflow-x-auto pb-2 mb-3">{keys.map(k => (
        <button key={k} type="button" onClick={() => setDay(k)} className={`shrink-0 px-3 py-2 rounded-lg text-sm font-semibold border transition-colors ${day === k ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-200 hover:border-slate-400"}`} data-testid={`slot-day-${k.replace(/\W+/g, "-")}`}>{k}</button>))}
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">{(days[day] || []).map(s => (
        <button key={s} type="button" onClick={() => onPick(s)} className={`py-2 rounded-lg text-sm font-semibold border transition-colors ${value === s ? "bg-blue-600 text-white border-blue-600" : "bg-white text-blue-700 border-blue-200 hover:bg-blue-50"}`} data-testid={`slot-${s}`}>{timeOf(s)}</button>))}
      </div>
    </div>
  );
};

export const fmtSlot = (iso) => new Date(iso).toLocaleString(undefined, { weekday: "long", month: "long", day: "numeric", hour: "numeric", minute: "2-digit" });
